import React from 'react';
import { useTranslation } from 'react-i18next';
import './FileTypeModal.css';

// Sabit veriyi, çeviri anahtarlarıyla güncelleyelim.
const fileTypes = [
  { nameKey: 'file_type_audio', iconClass: 'fas fa-volume-up', color: '#9b59b6', extensions: '.m4a, .mp3, .ogg, .wav, .wma, .aif, .amr, .aac' },
  { nameKey: 'file_type_office', iconClass: 'fas fa-file-word', color: '#3498db', extensions: '.doc, .docx, .odt, .rtf, .dot, .dotx, .docm, .dotm, .sxw' },
  { nameKey: 'file_type_desktop_publishing', iconClass: 'fas fa-file-pdf', color: '#e74c3c', extensions: '.inx' },
  { nameKey: 'file_type_web', iconClass: 'fas fa-code', color: '#34495e', extensions: '.htm, .html, .xhtml, .chm' },
  { nameKey: 'file_type_image', iconClass: 'fas fa-file-image', color: '#2ecc71', extensions: '.jpg, .jpeg, .jpe, .png, .gif, .tif, .tiff, .bmp' },
  { nameKey: 'file_type_acrobat', iconClass: 'fas fa-file-pdf', color: '#e74c3c', extensions: '.pdf' },
  { nameKey: 'file_type_presentation', iconClass: 'fas fa-file-powerpoint', color: '#f39c12', extensions: '.ppt, .pptx, .pps, .ppsx, .pot, .potx, .potm, .ppsm, .odp' },
  { nameKey: 'file_type_excel', iconClass: 'fas fa-file-excel', color: '#27ae60', extensions: '.xls, .xlsx, .ods, .xlt, .xltx, .xlsm, .csv' },
  { nameKey: 'file_type_text', iconClass: 'fas fa-file-alt', color: '#e67e22', extensions: '.txt, .po, .properties, .strings, .srt, .json' },
  { nameKey: 'file_type_video', iconClass: 'fas fa-file-video', color: '#8e44ad', extensions: '.avi, .m4v, .mov, .mp4, .mpg, .swf, .wmv, .asf, .vob' },
  { nameKey: 'file_type_xml', iconClass: 'fas fa-file-code', color: '#7f8c8d', extensions: '.resx, .xml, .xliff, .dfxp, .idml' },
];

const FileTypeModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation(); // useTranslation kancasını burada kullanıyoruz

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          {/* Başlığı t() fonksiyonu ile çeviriyoruz */}
          <h3>{t('modal_file_types_title')}</h3>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="modal-body">
          <div className="file-type-list">
            {fileTypes.map((type, index) => (
              <div className="file-type-row" key={index}>
                <div className="file-type-icon-name">
                  <span className="file-icon" style={{ backgroundColor: type.color }}>
                    <i className={type.iconClass}></i>
                  </span>
                  {/* Dosya türü adını t() fonksiyonu ile çeviriyoruz */}
                  {t(type.nameKey)}
                </div>
                <div className="file-type-extensions">{type.extensions}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FileTypeModal;